<template>
  <div class="component-list">
    <!-- <van-field
      v-for="(item, index) in value"
      :value="item.iccid"
      :label="item.type"
      :key="index"
      readonly
      input-align="right"
      @click="$emit('click', item, index)"
    >
      <template #button>
        <i v-if="!disable" class="imageicon imageicon-del" @click.stop="handleDeleteData(index)" />
      </template>
    </van-field> -->

    <div class="iccids" v-for="(item, index) in value" :key="index">
      <div class="iccid-line">
        <div class="line">
          <div class="title">TCU</div>
          <div class="iccid">{{ item.tcu }}</div>
        </div>
        <div class="line" v-if="'ecall' in item">
          <div class="title">ECALL</div>
          <div class="iccid">{{ item.ecall }}</div>
        </div>
      </div>
      <i v-if="!disable" class="imageicon del-icon imageicon-del" @click.stop="handleDeleteData(index)" />
    </div>

    <!-- <div v-for="(item, index) in value" :key="index">
      <van-field
        :value="item.tcu"
        label="TCU"
        readonly
        input-align="right"
        @click="$emit('click', item, index)"
      >
        <template #button>
          <i v-if="!disable" class="imageicon imageicon-del" @click.stop="handleDeleteData(index)" />
        </template>
      </van-field>
      <van-field
        :value="item.ecall"
        label="ECALL"
        readonly
        input-align="right"
      >
        <template #button>
          <i v-if="!disable" class="imageicon imageicon-del" @click.stop="handleDeleteData(index)" />
        </template>
      </van-field>
    </div> -->
  </div>
</template>

<script>
export default {
  name: 'List',
  props: {
    value: {
      type: Array,
      default: () => []
    },
    disable: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    /**
     * 删除数据
     * @param index 当前索引
     */
    handleDeleteData(index) {
      // 先拷贝一份数据
      const value = [...this.value]
      // 删除指定索引的数据
      value.splice(index, 1)
      // 开始双向绑定
      this.$emit('input', value)
    }
  }
}
</script>

<style lang="scss">
.component-list {
  .van-cell__title {
    padding-left: 0px;
    width: 120px;
  }
  .imageicon-del {
    margin-bottom: -6px;
    margin-left: 64px;
  }
  .iccids {
    display: flex;
    justify-content: space-between;
    align-items: center;
    .iccid-line {
      margin: 0 40px;
      .line {
        display: flex;
        justify-content: start;
        font-size: 30px;
        margin: 20px 0;
        .title {
          width: 120px;
        }
        .iccid {
          width: 520px;
        }
        .del-icon {
          width: 50px;
          height: 50px;
          color: #000;
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/List.vue